import type {ReactElement} from 'react';
import {Image} from 'react-bootstrap';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {DragDropOverlay} from '@Components/drag-drop-overlay/drag-drop-overlay';
import {getChatFileAcceptList} from '@Components/ai-prompt-box/libraries/ai-prompt-box-document-upload.library';
import {useAiPromptBox} from '@Components/ai-prompt-box/hooks/useAiPromptBox';
import {useAiPromptBoxDragDropUploader} from '@Components/ai-prompt-box/hooks/useAiPromptBoxDragDropUploader';
import type {AiChatDragDropOverlayProps} from './ai-chat-drag-drop-overlay.types';
import styles from './ai-chat-drag-drop-overlay.module.scss';

export function AiChatDragDropOverlay({promptBoxId, targetElement}: AiChatDragDropOverlayProps): ReactElement {
  const {handleFiles, showInvalidFileTypeError} = useAiPromptBoxDragDropUploader(promptBoxId);
  const acceptsDocuments = useAiPromptBox(promptBoxId).state.attachments?.acceptsDocuments ?? false;
  const headingKey = acceptsDocuments ? 'pmwjs_ai_chat_drag_drop_heading_files' : 'pmwjs_ai_chat_drag_drop_heading';
  const descriptionKey = acceptsDocuments ? 'pmwjs_ai_chat_drag_drop_description_files' : 'pmwjs_ai_chat_drag_drop_description';

  const hoverContent = (
    <div className={`_full-width _full-height ${styles.content}`}>
      <Image className={styles.overlayImage} src={getAssetUrl('ai-chat-drag-drop-overlay-image.webp')} alt={window.i18next.t(headingKey)} />
      <Text className={`spacing-m-t-4 content-body-white`} val={window.i18next.t(headingKey)} size={TextSize.LARGE} bold />
      <Text className="content-body-white" val={window.i18next.t(descriptionKey)} size={TextSize.SMALL} />
    </div>
  );

  return (
    <DragDropOverlay
      onFilesUpload={handleFiles}
      onHoverContent={hoverContent}
      className={styles.container}
      acceptedTypes={getChatFileAcceptList(acceptsDocuments)}
      onInvalidFileTypeError={showInvalidFileTypeError}
      targetElement={targetElement}
    />
  );
}
